import { LayoutModule } from '@angular/cdk/layout';
import { DatePipe } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { AppEnvironment } from '@ca/environment/app-environment.enum';
import { environment } from '@ca/environment/environment';
import { NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpCacheInterceptorModule } from '@ngneat/cashew';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { OAuthModule } from 'angular-oauth2-oidc';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgProgressModule } from 'ngx-progressbar';
import { ToastrModule } from 'ngx-toastr';
import { UiSwitchModule } from 'ngx-ui-switch';
import { HttpLoaderFactory, initialUserInfoRefresh } from '../utils/utils';
import { AppRoutingModule } from './app-routing.module';
import { AppStoreModule } from './app-store/app-store.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { RouteReuseService } from './core/services/route-reuse/route-reuse.service';
import { SharedModule } from './shared/shared.module';

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        LayoutModule,
        HttpCacheInterceptorModule.forRoot({
            // 10 minutes in ms
            ttl: 600000,
        }),
        NgbModule,
        StoreModule.forRoot({}),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: true,
        }),
        EffectsModule.forRoot([]),
        OAuthModule.forRoot(),
        AppRoutingModule,
        CoreModule,
        SharedModule,
        NgProgressModule,
        UiSwitchModule.forRoot({
            size: 'small',
            switchColor: '#008bd0',
        }),
        ToastrModule.forRoot({
            preventDuplicates: true,
            maxOpened: 10,
            toastClass: 'ngx-toastr toast-bootstrap-compatibility-fix',
            progressBar: true,
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        InlineSVGModule.forRoot(),
        AppStoreModule,
    ],
    providers: [
        ...(environment.type === AppEnvironment.Production ? [{ provide: ErrorHandler, useValue: Sentry.createErrorHandler() }] : []),
        {
            provide: NgbModalConfig,
            useValue: { size: 'lg', backdrop: true, centered: true },
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initialUserInfoRefresh,
            multi: true,
            deps: [Injector],
        },
        {
            provide: RouteReuseStrategy,
            useClass: RouteReuseService,
        },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
